import React from 'react'

const useRefWrapper = (initialValue) => React.useRef(initialValue)
export default useRefWrapper
